import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiUsers, FiCalendar, FiStar, FiSearch } from 'react-icons/fi';
import { Button } from '../components/Components';
import './Landing.css';

export default function Landing() {
  return (
    <div className="landing">
      {/* Nav */}
      <nav className="landing__nav">
        <div className="landing__nav-inner">
          <div className="landing__brand">
            <span className="landing__logo">◉</span>
            <span className="landing__logo-text">CoachConnect</span>
          </div>
          <div className="landing__nav-links">
            <Link to="/login" className="landing__nav-link">Sign In</Link>
            <Link to="/register"><Button size="sm">Get Started</Button></Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="landing__hero">
        <div className="landing__hero-bg">
          <div className="landing__orb landing__orb--1" />
          <div className="landing__orb landing__orb--2" />
          <div className="landing__orb landing__orb--3" />
          <div className="landing__grid-overlay" />
        </div>

        <div className="landing__hero-content">
          <div className="landing__badge-pill">
            ✦ Trusted by 10,000+ professionals
          </div>
          <h1 className="landing__headline">
            Find Your Perfect
            <br />
            <span className="landing__headline-accent">Coach Today</span>
          </h1>
          <p className="landing__subheadline">
            Connect with world-class coaches across 20+ domains.
            Book sessions that fit your schedule, accelerate your growth.
          </p>
          <div className="landing__cta-group">
            <Link to="/register?role=candidate">
              <Button size="lg">
                <FiSearch size={18} /> Find a Coach <FiArrowRight size={16} />
              </Button>
            </Link>
            <Link to="/register?role=coach">
              <Button variant="outline" size="lg">
                Become a Coach
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="landing__stats">
        {[
          { icon: <FiUsers />, value: '500+', label: 'Expert Coaches' },
          { icon: <FiSearch />, value: '20+', label: 'Domains' },
          { icon: <FiCalendar />, value: '50K+', label: 'Sessions Booked' },
          { icon: <FiStar />, value: '4.8★', label: 'Average Rating' },
        ].map(({ icon, value, label }) => (
          <div key={label} className="landing__stat">
            <div className="landing__stat-icon">{icon}</div>
            <div className="landing__stat-value">{value}</div>
            <div className="landing__stat-label">{label}</div>
          </div>
        ))}
      </section>

      {/* How It Works */}
      <section className="landing__how">
        <h2 className="landing__section-title">How It Works</h2>
        <div className="landing__steps">
          {[
            { num: '01', title: 'Create Your Profile', desc: 'Sign up as a coach or candidate. Share your expertise, interests, and goals.', icon: '👤' },
            { num: '02', title: 'Search & Discover', desc: 'Browse coaches by area of interest. Filter by expertise, rating, and availability.', icon: '🔍' },
            { num: '03', title: 'Book a Session', desc: 'Pick an available time slot that works for you. Sessions are confirmed instantly.', icon: '📅' },
            { num: '04', title: 'Grow Together', desc: 'Meet with your coach, gain insights, and accelerate your personal growth.', icon: '🚀' },
          ].map(({ num, title, desc, icon }) => (
            <div key={num} className="landing__step">
              <div className="landing__step-icon">{icon}</div>
              <div className="landing__step-num">{num}</div>
              <h3 className="landing__step-title">{title}</h3>
              <p className="landing__step-desc">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section className="landing__features">
        <h2 className="landing__section-title">For Coaches & Candidates</h2>
        <div className="landing__features-grid">
          <div className="landing__feature-col">
            <h3 className="landing__feature-heading">🏆 For Coaches</h3>
            <ul className="landing__feature-list">
              <li>Create a detailed profile with expertise & coaching interests</li>
              <li>Set your available time slots for the next 2 weeks</li>
              <li>Manage bookings and track your sessions</li>
              <li>Build your reputation with reviews and ratings</li>
              <li>Set your own hourly rate</li>
            </ul>
          </div>
          <div className="landing__feature-col">
            <h3 className="landing__feature-heading">🎓 For Candidates</h3>
            <ul className="landing__feature-list">
              <li>Search coaches by area of interest and expertise</li>
              <li>View available slots sorted by day — Today first</li>
              <li>Book sessions with one click</li>
              <li>Track upcoming and past sessions</li>
              <li>Leave reviews to help the community</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="landing__bottom-cta">
        <h2 className="landing__cta-title">Ready to Start Your Journey?</h2>
        <p className="landing__cta-desc">Join thousands of professionals growing with CoachConnect.</p>
        <Link to="/register">
          <Button size="lg">Create Free Account <FiArrowRight size={16} /></Button>
        </Link>
      </section>

      {/* Footer */}
      <footer className="landing__footer">
        <span className="landing__logo">◉</span>
        <span className="landing__footer-text">CoachConnect © 2026 — All rights reserved.</span>
      </footer>
    </div>
  );
}
